export default function validatePassword(password) {
  // regex check if password is between 8 and 32 characters and contains at least one lowercase letter, one uppercase letterSpacing, one number, and one special character
  const regex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&!@#$%^&*()_+])?[A-Za-z\d?&!@#$%^&*()_+]{8,32}$/

  return regex.test(password)
}
